<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header style="display: flex; justify-content: space-between; align-items: center;">
          <h1>Cursos</h1>
          <b style="padding: 7.5px 15px; border-radius: 70px; background-color: #FFF888;">
            <div style="display: flex">
              <span
                style="font-size: 15px; margin-top: 2.35px; margin-right: 7.5px;"
                class="material-icons"
              >
                dashboard
              </span>
              <span>
                SIMULAÇÃO
              </span>
            </div>
          </b>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <div class="margin">
          <vs-row vs-justify="left">
            <vs-row vs-align="flex-end" vs-justify="flex-end">
              <vs-button icon="unfold_more" @click="toggleAll" color="dark" type="border">
                Expandir/Ocultar - Todos
              </vs-button>
            </vs-row>
            <vs-col>
              <vs-collapse>
                <vs-collapse-item
                  v-for="(value, name) in courses"
                  :key="name"
                  :ref="name"
                  type="margin"
                >
                  <div slot="header">
                    <h3>{{ name }}</h3>
                  </div>
                  <div style="margin-top: 10px;">
                    <vs-card
                      class="event-course"
                      actionable
                      v-for="course in value"
                      :key="course.IDCLASSIFICACAO"
                    >
                      <div @click="selectCourse(course)">
                        <vs-row vs-justify="space-between">
                          <vs-col vs-w="9" vs-xs="12">
                            {{course.NOMECOMERCIAL}}
                          </vs-col>
                          <vs-col vs-w="3" vs-xs="12" v-if="course.NUMPARCELAS">
                            {{ course.NUMPARCELAS }}x de R${{(course.VALOR / course.NUMPARCELAS).toFixed(2)}}
                          </vs-col>
                          <vs-col vs-w="3" vs-xs="12" v-else>
                            <p style="font-size: 0.85em;font-style: italic;">
                              * Sem parcelamento padrão
                            </p>
                          </vs-col>
                        </vs-row>
                      </div>
                    </vs-card>
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </vs-col>
          </vs-row>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CoursesService from "../services/courses";
import { sortListByAttribute, updateStepsInformation } from "../helpers";
import { bus } from "../main";

export default {
  name: "Courses",
  data: () => ({
    courses: {},
    selected: null,
  }),
  mounted() {
    this.$vs.loading({
      color: "danger",
    });
    bus.$emit("updateSteps", 0);
    new CoursesService()
      .fetchCourses()
      .then((res) => {
        const categories = sortListByAttribute(res.data, "MODALIDADE");
        this.courses = categories;
        console.log(this.courses);
        this.$vs.loading.close();
      })
      .catch(() => {
        this.$vs.loading.close();
      });
  },
  computed: {
    selectedTitle() {
      if (this.selected) {
        return `Você selecionou: ${this.selected.NOMECOMERCIAL}`;
      }
      return "";
    },
  },
  methods: {
    selectCourse(course) {
      updateStepsInformation({
        courseSimulate: course,
        courseAttendance: "Selecionou Curso: " + course.NOMECOMERCIAL
      });
      this.$router.push("/simulate/branches");
    },
    toggleAll() {
      const coursesRefs = Object.keys(this.courses);
      const shouldExpand = coursesRefs.some(
        (ref) => this.$refs[ref][0].maxHeight === "0px"
      );
      coursesRefs.forEach((ref) => {
        const collapseItem = this.$refs[ref][0];
        if (shouldExpand) {
          if (collapseItem.maxHeight === "0px") {
            collapseItem.toggleContent();
          }
        } else {
          collapseItem.toggleContent();
        }
      });
    },
  },
};
</script>

<style scoped>
.margin {
  margin-bottom: 10px;
}

.event-course {
  box-shadow: 0px 0px 2px 1px #888888;
}

.event-course:hover {
  font-weight: bold;
  box-shadow: 0px 0px 3.5px 2.5px #9B0E1C;
}

</style>
